module.exports = __webpack_public_path__ + "img/back_100.22d2a729.jpg";